import * as actionTypes from './actionTypes';
import axios from 'axios'; 

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};

export const authSuccess = ( token, userId ) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        idToken: token,
        userId: userId
    };
};

export const authFailure = ( error ) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const checkAuthTimeout = ( expirationTime ) => {
    return dispatch => {
        setTimeout(() => {
            dispatch( logout() ); 
        }, expirationTime * 1000 );
    };
};

export const logout = () => {
    localStorage.removeItem( 'burger-token' );
    localStorage.removeItem( 'burger-expirationDate' );
    localStorage.removeItem( 'burger-userId' );
    return {
        type: actionTypes.AUTH_LOGOUT
    };
};

export const auth = (email, password, isSignup) => {
    return dispatch => {
        dispatch(authStart());

        const authData = {
            email: email,
            password: password,
            returnSecureToken: true
        }

        let url = 'https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyBZW5ElmL9soG_YXIbPBffTVdhPPxQxEQY';

        if(!isSignup) {
            url = 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyBZW5ElmL9soG_YXIbPBffTVdhPPxQxEQY';
        }

        axios.post(url, authData)
             .then(response => {
                //console.log(response);

                const expirationDate = new Date(new Date().getTime() + response.data.expiresIn * 1000);

                localStorage.setItem('burger-token', response.data.idToken);
                localStorage.setItem('burger-expirationDate', expirationDate);
                localStorage.setItem('burger-userId', response.data.localId);

                dispatch(authSuccess(response.data.idToken, response.data.localId));
                dispatch( checkAuthTimeout( response.data.expiresIn ) );
             })
             .catch(error => {
                 //console.log(error);
                 dispatch(authFailure(error.response.data.error));
             })
    };
}

export const setAuthenticationPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    }
}

export const authCheckState = () => {
    return dispatch => {
        const token = localStorage.getItem( 'burger-token');
        if( !token ){
            dispatch( logout() );
        }else{
            const expirationDate = new Date(localStorage.getItem( 'burger-expirationDate' ));

            if( expirationDate > new Date() ){
                const userId = localStorage.getItem( 'burger-userId');
                dispatch( authSuccess( token, userId ) );
                dispatch( checkAuthTimeout( ( expirationDate.getTime() - new Date().getTime() ) / 1000 ) );
            }else{
                dispatch( logout() );
            }
            
        }

    };
};